// eslint-disable-next-line no-restricted-imports
import { Group, Text } from '@mantine/core';
import { useTheme } from '@emotion/react';
import useTranslation from 'next-translate/useTranslation';

import type { CommissionerAssetType } from '~/domains/commissioner/interfaces/channel.interface';

import { assetConfig } from './consts';

type ImageUploadRulesProps = {
  assetType: CommissionerAssetType;
};

function ImageUploadRules({ assetType }: ImageUploadRulesProps) {
  const { fileSizeLimit, fileDimensionLimit, suggestedDimension, formats } = assetConfig[assetType];
  const theme = useTheme();
  const { t } = useTranslation('commissioner');
  return (
    <Group mt={theme.spacing.sm}>
      {suggestedDimension?.width && suggestedDimension?.height && (
        <Text size="sm" color="dimmed" inline>
          {t('onboarding.imageUploadRules.suggestedRes', {
            width: suggestedDimension.width,
            height: suggestedDimension.height,
          })}
        </Text>
      )}
      {fileSizeLimit && (
        <Text size="sm" color="dimmed" inline>
          {t('onboarding.imageUploadRules.maxFilesize', {
            fileSize: fileSizeLimit.max / 1024 / 1024,
          })}
        </Text>
      )}
      {fileDimensionLimit?.width?.min && fileDimensionLimit?.height?.min && (
        <Text size="sm" color="dimmed" inline>
          {t('onboarding.imageUploadRules.minRes', {
            minWidth: fileDimensionLimit.width.min,
            minHeight: fileDimensionLimit.height.min,
          })}
        </Text>
      )}
      {fileDimensionLimit?.width?.max && fileDimensionLimit?.height?.max && (
        <Text size="sm" color="dimmed" inline>
          {t('onboarding.imageUploadRules.maxRes', {
            maxWidth: fileDimensionLimit.width.max,
            maxHeight: fileDimensionLimit.height.max,
          })}
        </Text>
      )}
      {formats && (
        <Text size="sm" color="dimmed" inline>
          {t('onboarding.imageUploadRules.fileTypes', {
            formats: formats.join(', '),
          })}
        </Text>
      )}
    </Group>
  );
}

export default ImageUploadRules;
